import routes from "@/libs/endPoint/remocaoRoutes.js";
import routesServidor from "@/libs/endPoint/rh/servidorRoutes.js";
import routeDatasDistribuicao from "@/libs/endPoint/rh/DatasDistribuicaoRoutes.js";
import ApiServices from "@/services/uteis/ApiServices.js";
class RemocaoServices {
  constructor() {
    this.routes = routes;
    this.ApiServices = ApiServices;
    this.routesServidor = routesServidor;
    this.routeDatasDistribuicao = routeDatasDistribuicao;
  }

  async validarServidor(cpf, ano) {
    try {
      const url = this.routes.validarServidor(cpf, ano);

      const { data } = await this.ApiServices.get(url);
      return data;
    } catch (error) {
      console.error("Erro ao validar servidor:", error);
      throw error;
    }
  }
  async localizarMatriculas(cpf) {
    try {
      const url = `${this.routesServidor.matricula}/por-cpf/${cpf}`;

      const { data } = await this.ApiServices.get(url);
      return data;
    } catch (error) {
      console.error("Erro ao localizar matrículas:", error);
      throw error;
    }
  }
  async obterDatasDistribuicao(ano) {
    try {
      const url = this.routes.localizardatasEventos;

      const { data } = await this.ApiServices.get(url, { ano: ano });

      return data;
    } catch (error) {
      console.error("Erro ao obter datas de distribuição:", error);
      throw error;
    }
  }
}
export default new RemocaoServices();
